import React, { Component } from "react";
import { CustomTable, FormAddUser, FormEditUser } from "../../components";
import { PageTitle, LoadingSpinner, CustomModal, NotificationPopup, TruncatedCell, Pagination } from "../../common";
import { withRouter } from "react-router-dom";
import { useApiRequests } from "../../services";
import "./styles.scss";
import axios from "axios";

// Oldest year offered in the category-sums year filter (kudos history start).
const KUDOS_HISTORY_START_YEAR = 2021;

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allUsersData: [],
      selectedUserId: null,
      isDataFetching: true,
      isLoading: false,
      isModalOpen: false,
      isFormOpenned: true,
      isEditFormOpenned: false,
      selectedUserToEdit: [],
      newUserFullName: "",
      userType: null,
      currentUserType: localStorage.getItem("userType"),
      searchQuery: "", // New state for search query,
      isCancelPopupOpen: false,
      currentPage: 1,
      pageSize: 20,
      isImportSuccessPopupOpen: false,
      isImportErrorPopupOpen: false,
      importResultMessage: "",
      // Category filtering states
      categories: [],
      selectedCategoryId: null,
      selectedYear: null,
      usersWithCategorySums: [],
      showCategorySums: false,
      // Sorting state
      sortOrder: null, // null = no sort, 'asc' = ascending, 'desc' = descending
    };
    this.fetchData = this.fetchData.bind(this);
    this.onNewUserFullNameChange = this.onNewUserFullNameChange.bind(this);
    this.handleResetForm = this.handleResetForm.bind(this);
    this.handleUserDelete = this.handleUserDelete.bind(this);
    this.handleUserEditForm = this.handleUserEditForm.bind(this);
    this.handleUserEdit = this.handleUserEdit.bind(this);
    this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleCloseEditForm = this.handleCloseEditForm.bind(this);
    this.handleExportButton = this.handleExportButton.bind(this);
    this.handleImportButton = this.handleImportButton.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.fileInputRef = React.createRef();
  }

  async fetchData() {
    const { getAllUsers } = useApiRequests();
    const responseAllUsersData = await getAllUsers();
    this.setState({
      allUsersData: responseAllUsersData.data,
      isDataFetching: false,
    });
  }

  async componentDidMount() {
    try {
      const { getAllRequestKudosTypes } = useApiRequests();
      const categoriesResponse = await getAllRequestKudosTypes();
      this.setState({
        categories: categoriesResponse?.data || [],
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
    this.fetchData();
  }

  fetchUsersWithCategorySums = async (categoryId, year) => {
    // The category-sums view is gated on a selected category; year only refines it.
    if (!categoryId) {
      this.clearCategoryFilter();
      return;
    }

    this.setState({ isLoading: true });

    try {
      const { getUsersWithCategorySums } = useApiRequests();
      const response = await getUsersWithCategorySums(categoryId, year);
      this.setState({
        usersWithCategorySums: response?.data || [],
        showCategorySums: true,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching users with category sums:", error);
      this.setState({ isLoading: false });
    }
  };

  handleCategoryChange(e) {
    const categoryId = e.target.value ? parseInt(e.target.value) : null;
    // Clearing the category also drops the year refinement.
    const year = categoryId ? this.state.selectedYear : null;
    this.setState({ selectedCategoryId: categoryId, selectedYear: year, currentPage: 1 });
    this.fetchUsersWithCategorySums(categoryId, year);
  }

  handleYearChange = (e) => {
    const year = e.target.value ? parseInt(e.target.value) : null;
    this.setState({ selectedYear: year, currentPage: 1 });
    // Year refines the category view, so only refetch when a category is selected.
    if (this.state.selectedCategoryId) {
      this.fetchUsersWithCategorySums(this.state.selectedCategoryId, year);
    }
  };

  navigateToUserPage = (e, id) => {
    this.props.history.push(`/users/${id}`);
  };

  clearCategoryFilter = () => {
    this.setState({
      selectedCategoryId: null,
      selectedYear: null,
      showCategorySums: false,
      usersWithCategorySums: [],
    });
  }

  toggleSortOrder = () => {
    this.setState((prevState) => {
      if (prevState.sortOrder === null) return { sortOrder: 'desc', currentPage: 1 };
      if (prevState.sortOrder === 'desc') return { sortOrder: 'asc', currentPage: 1 };
      return { sortOrder: null, currentPage: 1 };
    });
  }

  handleModalToggle = (event) => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };

  handlePageChange = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  handlePageSizeChange = (size) => {
    this.setState({ pageSize: size, currentPage: 1 });
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleCancelAction = () => {
    this.setState({ isModalOpen: false, isCancelPopupOpen: true });
    setTimeout(() => {
      this.setState({ isCancelPopupOpen: false });
    }, 10000);
  };

  handleUserDelete = async (e) => {
    if (this.state.selectedUserId) {
      try {
        const apiRequests = useApiRequests(); // Use the useApiRequests function to get API functions

        const response = await apiRequests.deleteUserById(
          this.state.selectedUserId
        );

        if (response.status === 200) {
          this.setState({ isLoading: true, isModalOpen: false }, () => {
            setTimeout(() => {
              this.setState({
                isLoading: false,
                isEditFormOpenned: false,
                isFormOpenned: true,
              });
              this.fetchData();
            }, 200);
          });
        } else {
          // Handle error if needed
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  handleDeleteUserModal = (e, id) => {
    this.setState({
      selectedUserToEdit: [],
      selectedUserId: id,
      isModalOpen: true,
    });
  };

  handleUserEditForm = (e, user) => {
    this.setState({
      isEditFormOpenned: true,
      isFormOpenned: false,
      newUserFullName: user.fullName,
      selectedUserToEdit: user,
      selectedUserId: null,
    });
  };

  onNewUserFullNameChange = (event, value) => {
    this.setState({
      newUserFullName: event.target.value,
    });
  };

  handleResetForm = () => {
    this.setState({
      newUserFullName: "",
    });
  };

  handleCloseEditForm = () => {
    this.setState({
      isEditFormOpenned: false,
      isFormOpenned: true,
    });
  };

  handleUserEdit = async (e) => {
    this.setState({ selectedUserId: null });
    try {
      const apiRequests = useApiRequests(); // Use the useApiRequests function to get API functions

      const response = await apiRequests.editUserById(
        this.state.selectedUserToEdit.id,
        this.state.newUserFullName
      );

      if (response.status === 200) {
        this.setState({ isLoading: true, isModalOpen: false }, () => {
          setTimeout(() => {
            this.setState({
              isLoading: false,
              isEditFormOpenned: false,
              isFormOpenned: true,
              selectedUserToEdit: [],
            });
            this.fetchData();
          }, 700);
        });
      }
      return response;
    } catch (error) {
      console.log(error.message);
    }
  };

  handleAddNewUser = async () => {
    try {
      const apiRequests = useApiRequests();

      const response = await apiRequests.postAddNewUser(
        this.state.newUserFullName
      );

      if (response.status === 200) {
        this.props.fetchData();
      } else {
        // Handle error if needed
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  handleExportButton = async (e) => {
    try {
      const apiRequests = useApiRequests();
      // When the category filter is active, export the filtered view
      // (category sums, optionally per year) instead of all kudos totals.
      const { showCategorySums, selectedCategoryId, selectedYear, categories } = this.state;
      if (showCategorySums && selectedCategoryId) {
        const categoryName = categories.find((cat) => cat.id === selectedCategoryId)?.name || null;
        await apiRequests.exportData(selectedCategoryId, selectedYear, categoryName);
      } else {
        await apiRequests.exportData();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  handleImportButton = () => {
    this.fileInputRef.current.click();
  };

  handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Reset file input so the same file can be selected again
    e.target.value = "";

    this.setState({ isLoading: true });

    try {
      const apiRequests = useApiRequests();
      const response = await apiRequests.importUsers(file);

      const result = response.data;
      const message = `Import completed: ${result.usersAdded} added, ${result.usersUpdated} updated, ${result.usersMarkedDeleted} deleted`;

      this.setState({
        isLoading: false,
        isImportSuccessPopupOpen: true,
        importResultMessage: message,
      });

      setTimeout(() => {
        this.setState({ isImportSuccessPopupOpen: false });
      }, 10000);

      this.fetchData();
    } catch (error) {
      console.log(error.message);
      const errorData = error.response?.data;
      let errorMessage = "Import failed";

      if (typeof errorData === "string") {
        errorMessage = errorData;
      } else if (errorData?.errors?.length > 0) {
        errorMessage = errorData.errors.join(", ");
      } else if (error.message) {
        errorMessage = error.message;
      }

      this.setState({
        isLoading: false,
        isImportErrorPopupOpen: true,
        importResultMessage: errorMessage,
      });

      setTimeout(() => {
        this.setState({ isImportErrorPopupOpen: false });
      }, 10000);
    }
  };

  render() {
    const {
      userType,
      searchQuery,
      isDataFetching,
      allUsersData,
      currentPage,
      pageSize,
      categories,
      selectedCategoryId,
      selectedYear,
      usersWithCategorySums,
      showCategorySums,
      sortOrder,
    } = this.state;

    // Year options for the category-sums filter (most recent first).
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let y = currentYear; y >= KUDOS_HISTORY_START_YEAR; y--) {
      yearOptions.push(y);
    }

    // Determine which users to display based on filter mode
    let usersToDisplay;
    if (showCategorySums) {
      // When filtering by category, only show users with values > 0
      let filteredUsers = usersWithCategorySums.filter((user) => {
        const hasValue = user.categorySums?.some((cs) => cs.totalKudos > 0);
        return hasValue;
      });

      // Apply search filter
      if (searchQuery.trim()) {
        filteredUsers = filteredUsers.filter((user) => {
          const fullName = `${user.fullName}`.toLowerCase();
          return fullName.includes(searchQuery.toLowerCase());
        });
      }
      usersToDisplay = filteredUsers;
    } else {
      usersToDisplay = searchQuery.trim()
        ? allUsersData.filter((user) => {
            const fullName = `${user.fullName}`.toLowerCase();
            return fullName.includes(searchQuery.toLowerCase());
          })
        : allUsersData;
    }

    // Apply sorting if sortOrder is set
    if (sortOrder) {
      usersToDisplay = [...usersToDisplay].sort((a, b) => {
        let aValue, bValue;
        if (showCategorySums) {
          aValue = a.categorySums?.find(cs => cs.categoryId === selectedCategoryId)?.totalKudos || 0;
          bValue = b.categorySums?.find(cs => cs.categoryId === selectedCategoryId)?.totalKudos || 0;
        } else {
          aValue = a.amountOfKudos;
          bValue = b.amountOfKudos;
        }
        return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
      });
    }

    // Slice for client-side pagination
    const pageItems = usersToDisplay.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    // Sort indicator
    const sortIndicator = sortOrder === 'asc' ? ' ↑' : sortOrder === 'desc' ? ' ↓' : '';

    const showTableWithUsersInformationJSX = isDataFetching ? (
      <LoadingSpinner message="Loading..." />
    ) : (
      <>
        <PageTitle title="Visma - it is all about KUDOS!" />
        <div className="col-10 d-flex flex-column justify-content-center align-items-center">
          {this.state.isFormOpenned && this.state.currentUserType == 1 && (
            <>
              <FormAddUser
                fetchData={this.fetchData}
                isLoading={this.state.isLoading}
              />
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn"
                  onClick={(e) => this.handleExportButton(e)}
                >
                  Export to CSV
                </button>
                <input
                  type="file"
                  ref={this.fileInputRef}
                  onChange={this.handleFileChange}
                  accept=".xlsx,.xls"
                  style={{ display: "none" }}
                />
                <button
                  type="button"
                  className="btn"
                  onClick={this.handleImportButton}
                >
                  Import from Excel
                </button>
              </div>
            </>
          )}
          <input
            className="form-group search-group"
            type="text"
            placeholder="Search by Full Name..."
            value={searchQuery}
            onChange={(e) => this.setState({ searchQuery: e.target.value, currentPage: 1 })}
          />
          {process.env.REACT_APP_FEATURE_FILTERKUDOSPOINTSBYTYPE === "true" && (
            <div className="d-flex align-items-center mb-2" style={{ fontSize: "0.85rem", gap: "8px" }}>
              <select
                className="form-control form-control-sm"
                value={selectedCategoryId || ""}
                onChange={this.handleCategoryChange}
                style={{ width: "auto", minWidth: "180px", padding: "4px 8px" }}
              >
                <option value="">Filter by Category</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <select
                className="form-control form-control-sm"
                value={selectedYear || ""}
                onChange={this.handleYearChange}
                disabled={!selectedCategoryId}
                title={!selectedCategoryId ? "Select a category first" : "Filter by year"}
                style={{ width: "auto", minWidth: "180px", padding: "4px 8px" }}
              >
                <option value="">All years</option>
                {yearOptions.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
              {showCategorySums && (
                <button
                  onClick={this.clearCategoryFilter}
                  className="btn btn-sm btn-outline-secondary"
                  style={{ margin: "0px", height: "30px", width: "auto", minWidth: "50px" }}
                >
                  Clear filter
                </button>
              )}
            </div>
          )}
          {!this.state.isFormOpenned && (
            <>
              <FormEditUser
                selectedUserToEdit={this.state.selectedUserToEdit}
                newUserFullName={this.state.newUserFullName}
                onNewUserFullNameChange={this.onNewUserFullNameChange}
                handleResetForm={this.handleResetForm}
                fetchData={this.fetchData}
                handleModalToggle={this.handleModalToggle}
                handleCloseEditForm={this.handleCloseEditForm}
              >
                <CustomModal
                  handleModalToggle={this.handleModalToggle}
                  isModalOpen={this.state.isModalOpen}
                  handleModalClose={this.handleModalClose}
                  handleCancelAction={this.handleCancelAction}
                  handleSubmitForm={this.handleUserEdit}
                  message="Are you sure you want to edit this employee?"
                />
              </FormEditUser>
            </>
          )}
          <div className="custom-shadow mt-64 table-container">
            {this.state.selectedUserId &&
              !this.state.selectedUserToEdit.length && (
                <CustomModal
                  handleModalToggle={this.handleModalToggle}
                  isModalOpen={this.state.isModalOpen}
                  handleModalClose={this.handleModalClose}
                  handleCancelAction={this.handleCancelAction}
                  handleSubmitForm={this.handleUserDelete}
                  message="Are you sure you want to delete this employee?"
                />
              )}
            {this.state.isLoading && <LoadingSpinner />}
            <CustomTable customClassName="col-md-8 table table-hover table-active shadow-50 p-0">
              <thead>
                <tr>
                  <th key="0">Full Name</th>
                  <th
                    className="kudos-amount"
                    key="1"
                    onClick={this.toggleSortOrder}
                    style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
                  >
                    Kudos amount<span style={{ marginLeft: "4px" }}>{sortIndicator}</span>
                  </th>
                  {this.state.currentUserType == 1 && (
                    <th className="operations" key="2">
                      Operations
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {pageItems.map((user) => {
                  const userId = showCategorySums ? user.userId : user.id;
                  // Get the sum for the selected category
                  const categorySum = showCategorySums
                    ? user.categorySums?.find(cs => cs.categoryId === selectedCategoryId)?.totalKudos || 0
                    : user.amountOfKudos;
                  return (
                    <tr key={userId}>
                      <td
                        className="truncate-col"
                        onClick={(e) => this.navigateToUserPage(e, userId)}
                      >
                        <TruncatedCell text={user.fullName} />
                      </td>
                      <td onClick={(e) => this.navigateToUserPage(e, userId)}>
                        {categorySum}
                      </td>
                      {this.state.currentUserType == 1 && (
                        <td className="d-flex flex-row justify-content-between">
                          <>
                            <span
                              aria-hidden="true"
                              className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-edit mr-8"
                              onClick={(e) => {
                                this.handleUserEditForm(e, showCategorySums ? { ...user, id: user.userId } : user);
                                window.scrollTo(0, 0);
                              }}
                            ></span>
                            <span
                              aria-hidden="true"
                              className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-delete"
                              onClick={(e) =>
                                this.handleDeleteUserModal(e, userId)
                              }
                            ></span>
                          </>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </CustomTable>
            <Pagination
              currentPage={currentPage}
              totalItems={usersToDisplay.length}
              pageSize={pageSize}
              onPageChange={this.handlePageChange}
              onPageSizeChange={this.handlePageSizeChange}
              itemLabel="employees"
            />
          </div>
        </div>
        <NotificationPopup
          message="Action was canceled"
          isPopupOpen={this.state.isCancelPopupOpen}
          type="error"
        />
        <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999 }}>
          <NotificationPopup
            message={this.state.importResultMessage}
            isPopupOpen={this.state.isImportSuccessPopupOpen}
            type="success"
          />
          <NotificationPopup
            message={this.state.importResultMessage}
            isPopupOpen={this.state.isImportErrorPopupOpen}
            type="error"
          />
        </div>
      </>
    );

    return <>{showTableWithUsersInformationJSX}</>;
  }
}

export const Home = withRouter(HomePage);
